// function used to setup input groupings for each tier and program
export default function getInputGroupings(tier, program, inputMode = true) 
{
    tier = "Gold"; // cover old silvers

    var evaluationInputGroupings         = []
    let thisTierAndProgramInputGroupings = []

    // add body weight normalized kinetic tags if needed
    let student_anthro_tags = [ 'height' , 'seatedHeight' , 'weight' ];
    let forever_anthro_tags = [ 'height' , 'weight', 'sitAndReach' ];
    let next_level_anthro_tags = [ 'height' , 'weight', 'bodyFat' ];
    let rebuild_anthro_tags = [ 'height' , 'weight', 'seatedHeight' ];

    let student_sprint_tags = [ 'tenYard' , 'twentyYard' , 'five05_L' , 'five05_R' ];
    let next_level_sprint_tags = [ 'tenYard' , 'twentyYard' , 'thirtyYard' , 'fortyYard' , 'five10five_L' , 'five10five_R' ];

    let student_jump_tags = [ 'CMJ_FreeArms' ,'broadJump' ];
    let student_strength_tags = [ 'IMTP_PF' , 'IMTP_RFD' ];
    let forever_jump_tags = [ 'CMJ_FreeArms'];
    let forever_strength_tags = [ 'IMTP_PF' , 'IMTP_RFD' ];
    let next_level_jump_tags = [ 'CMJ_FreeArms' , 'squatJump_FreeArms' , 'broadJump', 'RSI' ];
    let next_level_strength_tags = [ 'IMTP_PF' , 'IMTP_RFD', 'groin_squeeze' ];
    let rebuild_jump_tags = [ 'CMJ_FreeArms' ,'broadJump' ];
    let rebuild_strength_tags = [ 'IMTP_PF' , 'IMTP_RFD' ];

    if (!inputMode)
    {
        student_anthro_tags      = [ ...student_anthro_tags, 'bmi', 'phv' ];
        forever_anthro_tags      = [ ...forever_anthro_tags, 'bmi' ];
        next_level_anthro_tags   = [ ...next_level_anthro_tags, 'bmi' ];
        rebuild_anthro_tags      = [ ...rebuild_anthro_tags, 'bmi' ];

        student_sprint_tags      = [ ...student_sprint_tags, 'sprint_speed' ];
        next_level_sprint_tags   = [ ...next_level_sprint_tags, 'sprint_speed' ];

        student_jump_tags        = [ ...student_jump_tags, 'cmj_peak_power_normalized' ];
        student_strength_tags    = [ ...student_strength_tags, 'IMTP_PF_normalized' , 'IMTP_RFD_normalized' ];
        forever_jump_tags        = [ ...forever_jump_tags, 'cmj_peak_power_normalized'];
        forever_strength_tags    = [ ...forever_strength_tags, 'IMTP_PF_normalized' , 'IMTP_RFD_normalized' ];
        next_level_jump_tags     = [ ...next_level_jump_tags, 'cmj_peak_power_normalized', 'ecc_util_jump' ];
        next_level_strength_tags = [ ...next_level_strength_tags, 'IMTP_PF_normalized' , 'IMTP_RFD_normalized' ];
        rebuild_jump_tags        = [ ...rebuild_jump_tags, 'cmj_peak_power_normalized' ];
        rebuild_strength_tags    = [ ...rebuild_strength_tags, 'IMTP_PF_normalized' , 'IMTP_RFD_normalized' ];
    }
    
    evaluationInputGroupings = 
    {
        Gold: 
        [
            { program: 'Next Level ATHlete', 
                inputGroupings:[
                    {groupName: 'Anthropometry'          , inputTags: next_level_anthro_tags                                                            },
                    {groupName: 'Movement Ability'       , inputTags: [ 'aslr_R','aslr_L', 'shoulderMob_R' , 'shoulderMob_L', 
                                                                        'rotation_spine', 'extension_spine', 'rotation_hip_L', 'rotation_hip_R', 
                                                                        'dflexion_ankle_L', 'dflexion_ankle_R'  ]                                       },
                    {groupName: 'Exercise Competency'    , inputTags: [ 'hinge' , 'squat' , 'pushup' ]                                                  },   
                    {groupName: 'Flexibility'            , inputTags: [ 'modThomas_psoas_R', 'modThomas_ITband_R', 'modThomas_quads_R', 
                                                                        'modThomas_psoas_L', 'modThomas_ITband_L', 'modThomas_quads_L',  ]              },
                    {groupName: 'Stability'              , inputTags: [ 'yBalance_R', 'yBalance_shldr_R', 'yBalance_hip_R', 'yBalance_knee_R',
                                                                        'yBalance_L', 'yBalance_shldr_L', 'yBalance_hip_L', 'yBalance_knee_L' ]         },                  
                    {groupName: 'Jumping Performance'    , inputTags: next_level_jump_tags                                                              },
                    {groupName: 'Sprinting Performance'  , inputTags: next_level_sprint_tags                                                            },
                    {groupName: 'Strength Performance'   , inputTags: next_level_strength_tags                                                          },
                    {groupName: 'Cardiometabolic Health' , inputTags: [ 'two000Rows' ]                                                                  },
                ]
            },

            { program: 'Forever ATHlete', 
                inputGroupings:[
                    {groupName: 'Anthropometry'          , inputTags: forever_anthro_tags                                                    },
                    {groupName: 'Movement Ability'       , inputTags: [ 'aslr_R','aslr_L', 'shoulderMob_R' , 'shoulderMob_L' , 'ohsquat' ]   },
                    {groupName: 'Exercise Competency'    , inputTags: [ 'hinge' , 'squat' , 'pushup' ]                                       },                    
                    {groupName: 'Jumping Performance'    , inputTags: forever_jump_tags                                                      },            
                    {groupName: 'Strength Performance'   , inputTags: forever_strength_tags                                                  },
                    {groupName: 'Cardiometabolic Health' , inputTags: ['five00Rows']                                                         },
                ]
            },

            { program: 'Prebuild ATHlete', 
                inputGroupings:[
                    {groupName: 'Anthropometry'          , inputTags: [ 'height' , 'weight', 'bmi']                                          },
                    {groupName: 'Exercise Competency'    , inputTags: [ 'shoulderIntRot_L' , 'shoulderIntRot_R' ]                            },                    
                    {groupName: 'Movement Ability'       , inputTags: [ 'sixMinWalk', 'fiveRepSitToStand', 'aslrDeg_R','aslrDeg_L']          },   
                ]
            },

            { program: 'Student ATHlete', 
                inputGroupings:[
                    {groupName: 'Anthropometry'         , inputTags: student_anthro_tags                                                    },
                    {groupName: 'Movement Ability'      , inputTags: [ 'aslr_R','aslr_L', 'shoulderMob_R' , 'shoulderMob_L' , 'ohsquat' ]   },
                    {groupName: 'Exercise Competency'   , inputTags: [ 'hinge' , 'squat' , 'pushup' ]                                       },                    
                    {groupName: 'Jumping Performance'   , inputTags: student_jump_tags                                                      },
                    {groupName: 'Sprinting Performance' , inputTags: student_sprint_tags                                                    },
                    {groupName: 'Strength Performance'  , inputTags: student_strength_tags                                                  },
                ]
            },

            { program: 'Rebuild ATHlete', 
                inputGroupings:[
                    {groupName: 'Anthropometry'         , inputTags: rebuild_anthro_tags                                                    },
                    {groupName: 'Movement Ability'      , inputTags: [ 'aslr_R','aslr_L', 'shoulderMob_R' , 'shoulderMob_L' , 'ohsquat' ]   },
                    {groupName: 'Exercise Competency'   , inputTags: [ 'hinge' , 'squat' , 'pushup' ]                                       },                    
                    {groupName: 'Jumping Performance'   , inputTags: rebuild_jump_tags                                                      },
                    {groupName: 'Sprinting Performance' , inputTags: [ 'tenYard' , 'twentyYard' , 'five05_L' , 'five05_R' ]                 },
                    {groupName: 'Strength Performance'  , inputTags: rebuild_strength_tags                                                  },
                ]
            },

            // { program: 'Team ATHlete', 
            //     inputGroupings:[
            //         {groupName: 'Anthropometry'         , inputTags: [ 'height' , 'seatedHeight' , 'weight' ]               },
            //         {groupName: 'Movement Ability'      , inputTags: [ 'ohsquat' ]                                          },
            //         {groupName: 'Jumping Performance'   , inputTags: [ 'CMJ_FreeArms' ]                                     },
            //         {groupName: 'Sprinting Performance' , inputTags: [ 'tenYard' , 'twentyYard' , 'five05_L' , 'five05_R' ] },
            //         {groupName: 'Strength Performance'  , inputTags: [ 'IMTP_PF' ]                                          },
            //     ]
            // }             
        ]   
    }

    if (program === "All")
    {
        // loop though evaluationInputGroupings
        //debugger 
        for (var i = 0; i < evaluationInputGroupings[tier].length; i++)
        {
            const thisInputGrouping = evaluationInputGroupings[tier][i].inputGroupings;

            // loop through each input grouping and if a matching gruopName is found, push the new inputTags into the existing inputTags array
            
            for (var j = 0; j < thisInputGrouping.length; j++)
            {
                let found = false;
                for (var k = 0; k < thisTierAndProgramInputGroupings.length; k++)
                {
                    if (thisInputGrouping[j].groupName === thisTierAndProgramInputGroupings[k].groupName)
                    {
                        found = true;
                        // add new inputTags to existing inputTags array
                        thisTierAndProgramInputGroupings[k].inputTags = thisTierAndProgramInputGroupings[k].inputTags.concat(thisInputGrouping[j].inputTags);
                        
                        // remove duplicates 
                        thisTierAndProgramInputGroupings[k].inputTags = thisTierAndProgramInputGroupings[k].inputTags.filter( function( item, index, inputArray ) {
                            return inputArray.indexOf(item) === index;
                        });
                        
                        break;
                    }
                }
                
                if (!found)
                {
                    thisTierAndProgramInputGroupings.push(thisInputGrouping[j]);
                }
            }
            
        }

        // // concatenate all input tags from all input groupings defined by currentInputGroupingIndex into one array
        // debugger
        // for (var p = 0; p < currentInputGroupingIndex.length; p++)
        // {
        //     thisTierAndProgramInputGroupings.push(tierInputGroupings[currentInputGroupingIndex[p]].inputGroupings);
        // }

        // // remove duplicates in thisTierAndProgramInputGroupings
        // thisTierAndProgramInputGroupings = thisTierAndProgramInputGroupings.filter( function( item, index, inputArray ) {
        //     return inputArray.indexOf(item) == index;
        // });
    }
    else
    {        
        // find inputgrouping object that match the requested tier and program
        const tierInputGroupings = evaluationInputGroupings[tier];

        // get index of tierInputGroupings that matches the program
        var currentInputGroupingIndex = tierInputGroupings.findIndex( function(tierInputGrouping){ return tierInputGrouping.program === program } ); 

        if (currentInputGroupingIndex === -1) // this is for the case where this is called before the athlete and input objects have properly been reset on athlete name and tier selection
            return null    
            
        thisTierAndProgramInputGroupings = tierInputGroupings[currentInputGroupingIndex].inputGroupings;

    }

    // return array of input groupings (and their inputs) that match the requested tier and program
    return thisTierAndProgramInputGroupings; 
}